import $ from 'jquery'
import _ from 'underscore'
import Settings from '../settings/Settings'
import AppUtils from '../utils/AppUtils'

// Printing library
import DownloadExtension from '../utils/DownloadUtils'
DownloadExtension($, this || window)

// Base URL for all API calls
const baseUrl = Settings.developmentMode
  ? 'http://localhost:8080/public'
  : `${window.location.protocol}//${window.location.host}/api/public`

// Higher-order function for ajax calls
const ajax = (method, url, queryHard = {}) => ({ id = null, product_id = null, data = null, query = {} }) => {

    // Build extended URL with ID
    let extendedUrl = url
    if (!_.isNull(id)) {
        extendedUrl = extendedUrl.replace("{id}", id.toString())
    }
    if (!_.isNull(product_id)) {
        extendedUrl = extendedUrl.replace("{product_id}", product_id.toString())
    }

    // Prepare query object
    _.extend(query, queryHard)
    query = _.size(query) === 0
      ? null
      : query

    // Prepare AJAX settings
    let settings = {
        method: method,
        url: baseUrl + extendedUrl + (_.isNull(query) ? '' : '?' + _.map(_.pairs(query), (param) => (encodeURIComponent(param[0]) + "=" + encodeURIComponent(param[1]))).join('&'))
    }
    if (!_.isNull(data)) {
        settings = _.extend({}, settings, {
            contentType: 'application/json',
            data: JSON.stringify(data)
        })
    }
    const user = AppUtils.store.getState().app.identity.user
    if (!_.isNull(user)) {
        settings = _.extend({}, settings, {
            headers: {
                'Authorization': 'Bearer ' + user.apikey
            }
        })
    }

    // Execute AJAX query
    return $.ajax(settings).fail((jqXHR, textStatus, errorThrown) => {
        if (jqXHR.status === 503) {
          window.location.reload()
        }
    })
}

// Higher-order function for download calls (printing of PDFs)
const download = (url, queryHard = {}) => ({ id = null, query = {} }) => {

    // Build extended URL with ID
    let extendedUrl = url
    if (!_.isNull(id)) {
        extendedUrl = extendedUrl.replace("{id}", id.toString())
    }

    // Get user for authentication
    const user = AppUtils.store.getState().app.identity.user

    // Prepare query object
    _.extend(
      query,
      queryHard,
      !_.isNull(user)
        ? {
            apikey: user.apikey
          }
        : {}
    )
    query = _.size(query) === 0
      ? null
      : query

    // Prepare AJAX settings
    extendedUrl = baseUrl + extendedUrl + (_.isNull(query) ? '' : '?' + _.map(_.pairs(query), (param) => (encodeURIComponent(param[0]) + "=" + encodeURIComponent(param[1]))).join('&'))

    // Execute file download
    return $.fileDownload(extendedUrl)
}

// Batteries API calls
export const listBatteries = ajax('GET', '/batteries')
export const postBattery = ajax('POST', '/battery')
export const getBattery = ajax('GET', '/battery/{id}')
export const putBattery = ajax('PUT', '/battery/{id}')
export const deleteBattery = ajax('DELETE', '/battery/{id}')

// Categories API calls
export const listCategories = ajax('GET', '/categories')
export const postCategory = ajax('POST', '/category')
export const getCategory = ajax('GET', '/category/{id}')
export const putCategory = ajax('PUT', '/category/{id}')
export const deleteCategory = ajax('DELETE', '/category/{id}')
export const reorderCategory = ajax('PUT', '/category/{id}/reorder')

// Colors API calls
export const listColors = ajax('GET', '/colors')
export const postColor = ajax('POST', '/color')
export const putColor = ajax('PUT', '/color/{id}')
export const deleteColor = ajax('DELETE', '/color/{id}')

// Controls API calls
export const listControls = ajax('GET', '/controls')
export const postControl = ajax('POST', '/control')
export const getControlBasic = ajax('GET', '/control/{id}', { content: 'basic' })
export const getControlFull = ajax('GET', '/control/{id}', { content: 'full' })
export const putControl = ajax('PUT', '/control/{id}')
export const deleteControl = ajax('DELETE', '/control/{id}')

// Controlled products API calls
export const postControlledProduct = ajax('POST', '/control/{id}/product/{product_id}')
export const getControlledProduct = ajax('GET', '/control/{id}/product/{product_id}')
export const putControlledProduct = ajax('PUT', '/control/{id}/product/{product_id}')
export const deleteControlledProduct = ajax('DELETE', '/control/{id}/product/{product_id}')

// Control groups API calls
export const postControlGroup = ajax('POST', '/control_group')
export const getControlGroup = ajax('GET', '/control_group/{id}')
export const putControlGroup = ajax('PUT', '/control_group/{id}')
export const deleteControlGroup = ajax('DELETE', '/control_group/{id}')
export const executeControlGroup = ajax('POST', '/control_group/{id}/execute')

// Control tasks API calls
export const postControlTask = ajax('POST', '/control_task')
export const getControlTask = ajax('GET', '/control_task/{id}')
export const putControlTask = ajax('PUT', '/control_task/{id}')
export const deleteControlTask = ajax('DELETE', '/control_task/{id}')

// Diameters API calls
export const listDiameters = ajax('GET', '/diameters')
export const postDiameter = ajax('POST', '/diameter')
export const getDiameter = ajax('GET', '/diameter/{id}')
export const putDiameter = ajax('PUT', '/diameter/{id}')
export const deleteDiameter = ajax('DELETE', '/diameter/{id}')

// Maintenances and executions API calls
export const postExecutionPhase1 = ajax('POST', '/execution', { phase: 1 })
export const postExecutionPhase2 = ajax('POST', '/execution', { phase: 2 })
export const getExecution = ajax('GET', '/execution/{id}')
export const putExecution = ajax('PUT', '/execution/{id}')
export const deleteExecution = ajax('DELETE', '/execution/{id}')
export const listMaintenances = ajax('GET', '/maintenances')
export const postMaintenance = ajax('POST', '/maintenance')
export const getMaintenanceBasic = ajax('GET', '/maintenance/{id}', { details: false })
export const getMaintenanceFull = ajax('GET', '/maintenance/{id}', { details: true })
export const putMaintenance = ajax('PUT', '/maintenance/{id}')
export const deleteMaintenance = ajax('DELETE', '/maintenance/{id}')

// Inventories API calls
export const listInventories = ajax('GET', '/inventories')
export const postInventoryPhase1 = ajax('POST', '/inventory', { phase: 1 })
export const postInventoryPhase2 = ajax('POST', '/inventory', { phase: 2 })
export const getInventory = ajax('GET', '/inventory/{id}')
export const putInventory = ajax('PUT', '/inventory/{id}')
export const deleteInventory = ajax('DELETE', '/inventory/{id}')

// Products and items API calls
export const postItem = ajax('POST', '/item')
export const getItemBasic = ajax('GET', '/item/{id}', { history: false })
export const getItemHistory = ajax('GET', '/item/{id}', { history: true })
export const putItem = ajax('PUT', '/item/{id}')
export const deleteItem = ajax('DELETE', '/item/{id}')
export const listProducts = ajax('GET', '/products')
export const postProduct = ajax('POST', '/product')
export const getProductMinimal = ajax('GET', '/product/{id}', { content: 'minimal' })
export const getProductBasic = ajax('GET', '/product/{id}', { content: 'basic' })
export const getProductFull = ajax('GET', '/product/{id}', { content: 'full' })
export const putProduct = ajax('PUT', '/product/{id}')
export const deleteProduct = ajax('DELETE', '/product/{id}')
export const reorderProduct = ajax('PUT', '/product/{id}/reorder')

// Locations API calls
export const listLocationsLinear = ajax('GET', '/locations', { tree: false })
export const listLocationsTree = ajax('GET', '/locations', { tree: true })
export const postLocation = ajax('POST', '/location')
export const getLocationBasic = ajax('GET', '/location/{id}', { details: false })
export const getLocationFull = ajax('GET', '/location/{id}', { details: true })
export const putLocation = ajax('PUT', '/location/{id}')
export const deleteLocation = ajax('DELETE', '/location/{id}')
export const reorderLocation = ajax('PUT', '/location/{id}/reorder')
export const listCompartments = ajax('GET', '/location/{id}/compartments')

// Owners API calls
export const listOwners = ajax('GET', '/owners')
export const postOwner = ajax('POST', '/owner')
export const getOwner = ajax('GET', '/owner/{id}')
export const putOwner = ajax('PUT', '/owner/{id}')
export const deleteOwner = ajax('DELETE', '/owner/{id}')

// Users API calls
export const listUsers = ajax('GET', '/users')
export const postUser = ajax('POST', '/user')
export const getUser = ajax('GET', '/user/{id}')
export const putUser = ajax('PUT', '/user/{id}')
export const deleteUser = ajax('DELETE', '/user/{id}')

// Authentification API calls
export const postLogin = ajax('POST', '/login')
export const getLogout = ajax('GET', '/logout')
export const putPassword = ajax('PUT', '/password')

// Printing API calls
export const printControl = download('/print/control/{id}')
export const printControlGroup = download('/print/control_group/{id}')
export const printBatteries = download('/print/batteries/{id}')
export const printFullInventory = download('/print/full_inventory')
export const printInventory = download('/print/location/{id}')
export const printInventoryToFill = download('/print/inventory_to_fill/{id}')
export const printOwner = download('/print/owner/{id}')
export const printProduct = download('/print/product/{id}')
export const printPipes = download('/print/pipes')



// WEBPACK FOOTER //
// ./src/actions/Api.js